import React from "react";
import { useTranslation } from "react-i18next";

import "./styles.scss";
import { EditProjectDetailsForm } from "./EditProjectDetailsForm";
import { ProjectData } from "../../../models/ProjectData";

interface IEditProjectDetailsModalProps {
  handleClose: () => void;
  project: ProjectData;
}

export const EditProjectDetailsModal: React.FunctionComponent<
  IEditProjectDetailsModalProps
> = (props) => {
  const { handleClose, project } = props;

  const { t: _t } = useTranslation();
  const t = (key: string) =>
    _t(`projectManagementPage.editProjectDetailsModal.${key}`);

  return (
    <div className="modal modal-default modal-edit-project-details">
      <div className="modal-mains">
        <button className="btn-close" onClick={handleClose}></button>
        <div className="modal-mains__body">
          <div className="top-title">
            <h2>{t("edit_project_details")}</h2>
          </div>
          <EditProjectDetailsForm
            handleCancel={handleClose}
            project={project}
          />
        </div>
      </div>
    </div>
  );
};
